export default {
    state: {
        adv_all_data_list: [],
        no_open_module:[],
        adv_down_list:[],
        local_media_header: '',
        kol_mkt_header: '',
        nav_adv_choose: '',
        home_introduction_type: '',
        setting_user_auth_adv_list: [],
        // notifications
        notifications_all_count: '',
        notifications_kind:'',
        allAuthList: {},
        login_user_role: '',
    },
    getters: {},
    mutations: {
        updateListByKey(state, { key, value }) {
            state[key] = value;
        },
        updateLocalMediaHeader(state, val) {
            state.local_media_header = val
        },
        updateKolmktHeader(state, val) {
            state.kol_mkt_header = val
        },
        updateAdvChoose(state, val) {
            state.nav_adv_choose = val
        },
        updateHomeIntroductionType(state, val) {
            state.home_introduction_type = val
        },
        updateSettingAuthAdvList(state, val) {
            state.setting_user_auth_adv_list = val
        },
        updateNotificationsAllCount(state, val) {
            state.notifications_all_count = val
        },
        updateAllAuthList(state, val) {
            state.allAuthList = val;
        },
        updateLoginUserRole(state, val) {
            state.login_user_role = val;
        },
        // updateNotificationKind(state,val){
        //     state.notifications_kind=val
        // }
    },
    actions: {},
    modules: {},
}


// WEBPACK FOOTER //
// ./src/stores/modules/config/index.js